// let Url = process.env.ADDRESS

export default {
  // 考试
  getExamList: '/api/v1/ext/agent/exam/getExamList', // 获取考试清单
  getExamInfo: '/api/v1/ext/agent/exam/getExamInfo',
  getExamResult: '/api/v1/ext/agent/exam/getExamResult',
  getQuestionList: '/api/v1/ext/agent/exam/generateExamPaper',
  savePaperAnswers: '/api/v1/ext/agent/exam/savePaperAnswers',
  handInPaper: '/api/v1/ext/agent/exam/handInPaper',
  getExamState: '/api/v1/ext/agent/exam/getExamState',
  checkNextTime: '/api/v1/ext/agent/exam/checkNextTime',
  invalidatorCheck: '/api/v1/ext/agent/exam/invalidatorCheck',
  fiveMinCheck: '/api/v1/ext/agent/exam/fiveMinCheck',
  getInductState: '/api/v1/ext/agent/induction/getInductState',
  checkLoginState: '/api/v1/ext/agent/exam/checkLoginState',
  checkCanExam: '/api/v1/ext/agent/exam/checkCanExam',
  // 考试后端
  queryQuestion: '/api/v1/ext/agent/exam/getQuestion',
  initManageCom: '/api/v1/ext/agent/exam/initT2ManageCom',
  deleteQuestion: '/api/v1/ext/agent/exam/deleteQuestion',
  tabEffective: '/api/v1/ext/agent/exam/updateQuestionEffective',
  saveAndUpdateQuestion: '/api/v1/ext/agent/exam/saveQuestion',
  saveExamPaper: '/api/v1/ext/agent/exam/saveExamPaperType',
  deleteExamPaper: '/api/v1/ext/agent/exam/deleteExamPaperType',
  initExamPaperType: '/api/v1/ext/agent/exam/initExamPaperType',
  initQuestionNum: '/api/v1/ext/agent/exam/initQuestionNum',
  initAllManageCom: '/api/v1/ext/agent/exam/initManageCom',
  reviewExamPaper: '/api/v1/ext/agent/exam/reviewExamPaper',
  getExamDetails: '/api/v1/ext/agent/exam/getExamDetails',
  getExamSummary: '/api/v1/ext/agent/exam/getExamSummary',
  exportExamDetail: '/api/v1/ext/agent/exam/exportExamDetail',
  exportExamSummary: '/api/v1/ext/agent/exam/exportExamSummary',
  importQuestion: '/api/v1/ext/agent/exam/importQuestion',
  // 入司
  setSignInformation: '/api/v1/ext/agent/induction/saveSignInfo', // 保存入司签署信息总接口
  getSignInformation: '/api/v1/ext/agent/induction/getSignInfo',
  saveInCompanyImage: '/api/v1/ext/agent/induction/saveInCompanyImage', // 入司影像
  getInCompanyImage: '/api/v1/ext/agent/induction/getInCompanyImage',
  saveAgencyContract: '/api/v1/ext/agent/induction/saveAgentContract', // 代理合同
  getAgencyContract: '/api/v1/ext/agent/induction/initAgentContract', // 初始化代理合同
  // 入司基本信息
  getBaseInfo: '/api/v1/ext/agent/induction/getBaseInfo',
  saveBaseInfo: '/api/v1/ext/agent/induction/saveBaseInfo',
  getSignState: '/api/v1/ext/agent/induction/getSignState',

  // 绩效查询
  getPuserInfo: '/api/v1/ext/agent/performance/getUserBaseInfo',
  getQueryAgentInfo: 'api/v1/hasl/policy/service/queryAgentInfo',
  getTeamInfo: '/api/v1/ext/agent/performance/getTeamInfo',
  getTeamTree: '/api/v1/ext/agent/performance/getTeamtree',
  getPersonalAssessmentInfo: '/api/v1/ext/agent/performance/getPersonalAssessmentInfo',
  getPersonalConRate: '/api/v1/ext/agent/performance/getPersonalConRate',
  getPersonalConRateDetail: '/api/v1/ext/agent/performance/getPersonalConRateDetail',
  getTeamConRate: '/api/v1/ext/agent/performance/getTeamConRate',
  getTeamAssessment: '/api/v1/ext/agent/performance/getTeamAssessment',
  getCertificates: '/api/v1/ext/agent/performance/getCertificates',
  trajectory: '/api/v1/ext/agent/performance/getTrajectory',
  exportExcel: '/api/v1/ext/agent/performance/exportExcel',
  getTeamPersonInfo: '/api/v1/ext/agent/performance/getTeamPersonInfo',
  getAgentInfo: '/api/v1/ext/policy/query/getAgentInfo', // 获取营销信息
  getAgentHistory: '/api/v1/ext/policy/query/getAgentHistory', // 营销历史
  getTeam: '/api/v1/ext/policy/query/getTeam', // 获取团队信息
  getOptions: '/api/v1/ext/policy/query/getOptions', // 新单操作历史记录
  getNoteInfo: '/api/v1/ext/policy/query/getNoteInfo', // 新单照会信息
  getRecvFirst: '/api/v1/ext/policy/query/getRecvFirstInfo', // 首期扣款记录
  getRecv: '/api/v1/ext/policy/query/getRecvInfo', // 续期记录
  getPolicyBonus: '/api/v1/ext/policy/query/getPolicyBonus', // 红利现金明细
  getSnapshot: '/api/v1/ext/policy/query/getSnapshot', // 现金价值
  getEXPY: '/api/v1/ext/policy/query/getEXPY', // 生存金
  getCallBack: '/api/v1/ext/policy/query/getCallBack', // 回访
  // 内容管理
  initPublishTypes: '/api/v1/ext/cms/content/initPublishTypes', // 初始化发布类型
  initVisiblePeople: '/api/v1/ext/cms/content/initVisiblePeople', // 初始化可见人员
  getContentList: '/api/v1/ext/cms/content/getContentList', // 获取内容列表
  publishContent: '/api/v1/ext/cms/content/publishContent', // 发布、取消发布
  deleteContent: '/api/v1/ext/cms/content/deleteContent', // 删除发布
  stickContent: '/api/v1/ext/cms/content/stickContent', // 置顶内容
  searchContent: '/api/v1/ext/cms/content/searchContent', // 搜索内容
  saveContent: '/api/v1/ext/cms/content/saveContent', // 编辑、添加内容

  cancelTiming: '/api/v1/ext/cms/content/cancelTiming', // 取消定时发布
  updatePublishTime: '/api/v1/ext/cms/content/updatePublishTime', // 修改发布时间
  previewContent: '/api/v1/ext/cms/content/previewContent', // 预览
  getContent: '/api/v1/ext/cms/content/getContent', // 获取详情
  initInformation: '/api/v1/ext/cms/content/initInformation', // 资讯公司新闻
  initChannelInfo: '/api/v1/ext/cms/content/initChannelInfo', // 资讯渠道新闻
  // 活动量统计
  getAgentChannel: '/api/v1/ext/agent/train/getAgentChannel',
  getActivityGroupTree: '/api/v1/ext/agent/activity/getActivityGroupTree',
  exportActivityGroupSummary: '/api/v1/ext/agent/activity/exportActivityGroupSummary',
  exportActivityGroupNum: 'exportActivityGroupSummary/api/v1/ext/agent/activity/exportActivityGroupNum',
  // 初始化日历
  initCalendar: '/api/v1/ext/agent/activity/initCalendar', // 初始化日历
  // 培训
  batchTabState: '/api/v1/ext/agent/train/batchTabCourseState',

  // 消息中心
  getAllType: '/api/v1/ext/cms/message/getAllType',
  getMessage: '/api/v1/ext/cms/message/getMessage',
  clear: '/api/v1/ext/cms/message/clear',
  tabRead: '/api/v1/ext/cms/message/tabRead',
  tabAllRead: '/api/v1/ext/cms/message/tabAllRead',

  // getContent: '/v1/ext/cms/content/getContent'

  // 首页初始化
  getHotProductAndHeadline: '/api/v1/ext/cms/content/getProductAndHeadline',
  // 产品列表
  getProducts: '/api/v1/ext/cms/content/getProducts',
  // 天气接口
  getWeather: '/api/v1/ext/agent/activity/getTemp',
  // 创说会
  activityBasicInfoCreate: '/api/v1/ext/octahedral/activity/activityBasicInfoCreate', // 创建活动-保存活动基本信息
  getActivityBasicInfoById: '/api/v1/ext/octahedral/activity/getActivityBasicInfoById', // 创建活动-查询活动基本信息
  getQRUrl: '/api/v1/ext/octahedral/activity/getQRUrl', // 生成二维码
  invitationBasicInfoCreate: '/api/v1/ext/octahedral/invitation/invitationBasicInfoCreate', // 创建活动-保存邀请函
  getInvitationBasicInfoById: '/api/v1/ext/octahedral/invitation/getInvitationBasicInfoById', // 创建活动-通过id 查询邀请函信息
  getAwardTempList: '/api/v1/ext/octahedral/award/getAwardTempList', // 创建活动-抽奖配置模板列表
  getAwardBaseInfoById: '/api/v1/ext/octahedral/award/getAwardBaseInfoById', // 创建活动-抽奖配置模板详情 // 抽奖详情-通过抽id 查询奖项信息
  activityPrizeInfoCreate: '/api/v1/ext/octahedral/award/activityPrizeInfoCreate', // 创建活动-保存中奖配置
  getAwardTempListWithPage: '/api/v1/ext/octahedral/award/getAwardTempListWithPage', // 抽奖列表-抽奖列表接口
  stopAwardTemp: '/api/v1/ext/octahedral/award/stopAwardTemp', // 抽奖列表-模板停用
  awardBaseInfoCreate: '/api/v1/ext/octahedral/award/awardBaseInfoCreate', // 抽奖详情-保存抽奖模板
  getAwardTempCreateUser: '/api/v1/ext/octahedral/award/getAwardTempCreateUser', // 抽奖配置 创建人列表
  getActivityInfoWithPage: '/api/v1/ext/octahedral/service/getActivityInfoWithPage', // 活动管理-通过条件信息 查询活动列表
  exportActivityInfo: '/api/v1/ext/octahedral/service/exportActivityInfo', // 活动管理-导出
  saveLottery: '/api/v1/ext/octahedral/award/saveLottery', // 活动开奖-开奖状态
  getActivityPrizeInfoById: '/api/v1/ext/octahedral/award/getActivityPrizeInfoById', // 活动管理 编辑活动返显奖品
  releaseActivity: '/api/v1/ext/octahedral/activity/releaseActivity', // 活动管理 发布
  getManagecomLst: '/api/v1/ext/octahedral/activity/getManagecomLst', // 活动管理 获取机构列表
  getAwardPrizeByActivityId: '/api/v1/ext/octahedral/award/getAwardPrizeByActivityId', // 活动开奖-查询通过活动id,查询奖品
  getAwardedCustomerByActivityId: '/api/v1/ext/octahedral/award/getAwardedCustomerByActivityId', // 活动开奖-查询中奖列表
  resetLottery: '/api/v1/ext/octahedral/award/resetLottery', // 活动开奖-重新开奖
  setStatisticsByActivityId: '/api/v1/ext/octahedral/statistics/setStatisticsByActivityId', // 活动统计触发
  getAwardedCustomerWithPage: '/api/v1/ext/octahedral/award/getAwardedCustomerWithPage', // 中奖名单列表（分页）
  exportAwardedCustomer: '/api/v1/ext/octahedral/award/exportAwardedCustomer', // 中奖名单导出
  saveCustomerReceiveStatus: '/api/v1/ext/octahedral/customer/saveCustomerReceiveStatus', // 开奖名单-更新领奖状态
  getOutParticipants: '/api/v1/ext/octahedral/service/getOutParticipants', // 参会外勤-通过活动id 查询外勤列表
  exportOutParticipants: '/api/v1/ext/octahedral/activity/exportOutParticipants', // 参会外勤导出
  getParticipantUsers: '/api/v1/ext/octahedral/service/getParticipantUsers', // 参会用户-通过活动id 查询外部人员进度表
  exportParticipantUsers: '/api/v1/ext/octahedral/activity/exportParticipantUsers', // 参会用户名单导出
  getActivityImgsWithPage: '/api/v1/ext/octahedral/service/getActivityImgsWithPage', // 活动图片-查询图片列表
  getOrganizationStatistics: '/api/v1/ext/octahedral/service/getOrganizationStatistics', // 查询机构统计列表
  exportOrganizationStatistics: '/api/v1/ext/octahedral/service/exportOrganizationStatistics', // 机构统计-导出
  getActivityStatistics: '/api/v1/ext/octahedral/service/getActivityStatistics', // 查询活动统计列表
  exportActivityStatistics: '/api/v1/ext/octahedral/service/exportActivityStatistics', // 会议统计-导出
  getSalesmanStatistics: '/api/v1/ext/octahedral/service/getSalesmanStatistics', // 查询业务员统计列表
  exportSalesmanStatistics: '/api/v1/ext/octahedral/service/exportSalesmanStatistics', // 业务员统计-导出
  getSalesmanDetailStatistics: '/api/v1/ext/octahedral/service/getSalesmanDetailStatistics', // 查询业务员明细统计列表
  exportSalesmanDetailStatistics: '/api/v1/ext/octahedral/service/exportSalesmanDetailStatistics', // 业务员明细-导出
  getParticipants: '/api/v1/ext/octahedral/service/getParticipants', // 参与人员查询
  exportParticipants: '/api/v1/ext/octahedral/service/exportParticipants', // 参与人员导出
  checkAllowUpdate: '/api/v1/ext/octahedral/activity/checkAllowUpdate', //判断活动是否可以编辑
  getQRcodes: '/api/v1/ext/octahedral/activity/getQRcodes', //下载签到和抽奖二维码链接
  getUserRoles: '/api/v1/ext/agent/performance/getUserRoles', // 权限-查询角色权限
  //孤儿单
  getOrphanPolicy: '/api/v1/ext/agent/orphan/getOrphanPolicy',
  getOrphanPolicyInfo: '/api/v1/ext/agent/orphan/getOrphanPolicyInfo',
  handleOrphanPolicy: '/api/v1/ext/agent/orphan/handleOrphanPolicy',
  //续期扣款查询
  getRenewalPolicy: '/api/v1/ext/agent/orphan/getRenewalPolicy',
  getPolicyBasicInfo: '/api/v1/ext/policy/query/getPolicyBasicInfo',
  getAccountInfo: '/api/v1/ext/policy/query/getAccountInfo',
  getPersonerInfo: '/api/v1/ext/policy/query/getPersonerInfo',
  //预收查询
  getAdvance: '/api/v1/ext/agent/advance/getAdvance',
  createOppositeData: '/api/v1/ext/agent/advance/createOppositeData',
  //预收统计
  getAdvanceStatistics: '/api/v1/ext/agent/advance/getAdvanceStatistics',
  getRiskStatistics: '/api/v1/ext/agent/advance/getRiskStatistics',
  getKPI: '/api/v1/ext/agent/advance/getKPI',
  getOrgList: '/api/v1/ext/agent/advance/getOrgList',
  checkUserIsSupport: '/api/v1/ext/agent/advance/checkUserIsSupport',
  getEstimate: '/api/v1/ext/agent/advance/getEstimate',//承保预估
  exportEstimate: '/api/v1/ext/agent/advance/exportGetEstimateExcel',//承保预估

  //预收导出
  exportAdvanceStatistics: '/api/v1/ext/agent/advance/exportAdvanceStatistics',
  exportRistStatistic: '/api/v1/ext/agent/advance/exportRistStatistic',
  exportSalePersonDetail: '/api/v1/ext/agent/advance/exportSalePersonDetail',
  exportPolicyDetail: '/api/v1/ext/agent/advance/exportPolicyDetail',
  exportPolicyRisk: '/api/v1/ext/agent/advance/exportPolicyRisk',
  exportKpi: '/api/v1/ext/agent/advance/exportKpi',
  getCustomers: '/api/v1/ext/agent/customer/getCustomers',
  getCustomerInfo: '/api/v1/ext/agent/customer/getCustomerInfo', // 获取客户信息
  getCustomerPolicyInfo: '/api/v1/ext/agent/customer/getCustomerPolicyInfo', // 获取客户保单信息
  //销售资格升级
  getRiskList: '/api/v1/ext/agent/saleExam/getRiskList', //获取险种列表
  getAuthRisks: '/api/v1/ext/agent/saleExam/getAuthRisks', //获取授权险种列表
  tabShelfState: '/api/v1/ext/agent/saleExam/tabShelfState', //切换险种上架状态
  exportAuthRisks: '/api/v1/ext/agent/saleExam/exportAuthRisks', //切换险种上架状态

  initRiskTypes: '/api/v1/ext/agent/saleExam/initRiskTypes', //获取险种类型列表
  saveInternetPaperType: '/api/v1/ext/agent/exam/saveInternetPaperType',// 保存互联网配置
  calculateQuestionCount: 'api/v1/ext/agent/saleExam/calculateQuestionCount', //计算试题数量
  getRiskExamSummary: '/api/v1/ext/agent/saleExam/getRiskExamSummary', //销售资格考试汇总
  exportRiskExamSummary: '/api/v1/ext/agent/saleExam/exportRiskExamSummary',//导出销售资格考试汇总
  getSaleAuthRiskTotal: '/api/v1/ext/agent/saleExam/getSaleAuthRiskTotal',// 获取销售人员可售汇总
  getAuthRiskDetail: '/api/v1/ext/agent/saleExam/getAuthRiskDetail',//获取销售人员授权详情
  exportSaleAuthRiskTotal: '/api/v1/ext/agent/saleExam/exportSaleAuthRiskTotal', //可售汇总导出
  exportAuthRiskDetail: '/api/v1/ext/agent/saleExam/exportAuthRiskDetail', //授权导出

  getConsultTypes: '/api/v1/ext/agent/consult/getConsultTypes',//回去咨询类型
  replyConsult: '/api/v1/ext/agent/consult/replyConsult',//咨询回复
  getConsults: '/api/v1/ext/agent/consult/getConsults', //获取列表
  getConsultDetailPC: '/api/v1/ext/agent/consult/getConsultDetailPC',//获取别表详情
  modifyReply: '/api/v1/ext/agent/consult/modifyReply', //修改咨询回复
  getRateAdPc: '/api/v1/ext/agent/advance/getRateAdPc', //经代公司继续率列表
  exportRateAd: '/api/v1/ext/agent/advance/exportRateAd',//导出经代公司excel

  importVipInfo: '/api/v1/ext/agent/vas/importVipInfo', //尊享导入
  getVipPersonInfoList: '/api/v1/ext/agent/vas/getVipPersonInfoList', //尊享导入
  getImportState: '/api/v1/ext/agent/vas/getImportState',//导入状态

  //预收统计渠道
  getAdvanceChannel: '/api/v1/ext/agent/advance/getAdvanceChannel',

  checkThreeElementByFile: '/api/v1/ext/agent/customer/checkThreeElementByFile',//文件三要素鉴权
  getThreeElementVerifyHis: '/api/v1/ext/agent/customer/getThreeElementVerifyHis', //文件三要素鉴权操作轨迹

  // 业绩报告管理
  getTeamTypeAndMember: '/api/v1/ext/agent/entrepreneurs/getTeamTypeAndMember', // 获取业绩展示权限
  getTeamPerformanceReportPC: '/api/v1/ext/agent/entrepreneurs/getTeamPerformanceReportPC', // 查询
  saveOrUpdateTeamPerformanceReport: '/api/v1/ext/agent/entrepreneurs/saveOrUpdateTeamPerformanceReport', // 保存
  deleteTeamPerformanceReport: '/api/v1/ext/agent/entrepreneurs/deleteTeamPerformanceReport', // 删除
  getEsgReports: '/api/v1/ext/agent/entrepreneurs/getEsgReports', // 查询ESG
  deleteEsgReports: 'api/v1/ext/agent/entrepreneurs/deleteEsgReports', // 删除ESG
  getEsgReportDetail: '/api/v1/ext/agent/entrepreneurs/getEsgReportDetail', // 查询当前ESG报告
  editEsgReports: '/api/v1/ext/agent/entrepreneurs/editEsgReports', // 新增或编辑ESG报告

  // 订单管理
  getOrderList: '/api/v1/huize/gb/application/getOrderList', // 获取订单管理表格数据的接口
  getOrderEnum: '/api/v1/huize/gb/application/getOrderEnum', // 获取业务来源和分公司下拉菜单数据的接口
  getOrderInfo: '/api/v1/huize/gb/application/getOrderInfo', // 查询保单详情的接口
  getExcel: '/api/v1/huize/gb/application/getExcel', // 导出文件的接口

  // 证件核实
  queryCustomerList: '/api/v1/ext/agent/advance/queryCustomerList',  //客户列表查询
  queryCustomerDetails: '/api/v1/ext/agent/advance/queryCustomerDetails', // 客户详情接口
  querySalesStaffDetails: '/api/v1/ext/agent/advance/querySalesStaffDetails', //销售人员明细查询
  summaryStatistics:'/api/v1/ext/agent/advance/summaryStatistics', // （机构维度）客户证件核实汇总统计查询
  exportCustomerDetails:'/api/v1/ext/agent/advance/exportCustomerDetails', // 客户明细导出
  exportQuerySalesStaffDetails: '/api/v1/ext/agent/advance/exportQuerySalesStaffDetails',
  exportSummaryStatistics: '/api/v1/ext/agent/advance/exportSummaryStatistics',

  //通用保全
  getNoProcessedOrders:'/api/v1/ext/wechat2/edor/getNoProcessedOrders',//待处理列表
  cancellation:'/api/v1/ext/wechat2/edor/cancellation',//撤单
  alreadySubmitted:'/api/v1/ext/wechat2/edor/alreadySubmitted',//已提交
  getProcessedOrders:'/api/v1/ext/wechat2/edor/getProcessedOrders',//已提交
  processingCompleted:'/api/v1/ext/wechat2/edor/processingCompleted',//已提交
  materialDownload:'/api/v1/ext/wechat2/edor/materialDownload',//下载
  materialPreview:'/api/v1/ext/wechat2/edor/materialPreview',//预览

  // 页面初始化判断是否签署过承诺书的接口
  checkPayPromiseBookSign: '/api/v1/ext/agent/other/checkPayPromiseBookSign',

  // 入司管理
  getOrgListInduction: '/api/v1/ext/agent/induction/pcGetOrgList', // 银保入司查询机构数据的接口
  queryListOfBank:'/api/v1/ext/agent/induction/queryListOfBank', // 查询表格数据
  inductionMaterialDownload:'/api/v1/ext/agent/induction/materialDownload',
  // 荣誉体系管理
  saveHonorInfoByPc: '/api/v1/ext/agent/honor/saveHonorInfoByPc', // PC端年度，月度荣誉名称和标准-保存
  queryHonorListByPc: '/api/v1/ext/agent/honor/queryHonorListByPc', // PC端年度，月度荣誉名称和标准-查询
  exportHonorInfoByPc: '/api/v1/ext/agent/honor/exportHonorInfoByPc', // PC端年度，月度荣誉名称和标准-导出
  queryHonorAchievement: '/api/v1/ext/agent/honor/queryHonorAchievement', // 年度，月度荣誉业绩维护-查询
  importHonorAchievement: '/api/v1/ext/agent/honor/importHonorAchievement', // 年度，月度荣誉业绩维护-导入
  exportHonorAchievement: '/api/v1/ext/agent/honor/exportHonorAchievement', // 年度，月度荣誉业绩维护-导出
  deleteHonorAchievement: '/api/v1/ext/agent/honor/delHonorAchievement', // 年度，月度荣誉业绩维护- 删除
  updateHonorAchievement: '/api/v1/ext/agent/honor/updateHonorAchievement', // 年度、月度荣誉业绩维护-修改

 // 招募流程优化
 getOrgListService: '/api/v1/hasl/recruit/service/getOrgList', // 获取机构列表(3级联动)
 getEnumList: '/api/v1/hasl/recruit/service/getEnumList', // 字典表
 getAgentRole: '/api/v1/hasl/recruit/service/getAgentRole', // 获取内勤人员角色

 queryAccountAgentList: '/api/v1/hasl/recruit/service/queryAccountAgentList',  // 查询内勤人员信息列表
 exportAgentList: '/api/v1/hasl/recruit/service/exportAgentList', // 导出内勤人员清单
 getAccountAgent: '/api/v1/hasl/recruit/service/getAccountAgent', //获取内勤人员信息
 saveAccountAgent: '/api/v1/hasl/recruit/service/saveAccountAgent', //保存内勤人员信息
 deleteAccountAgent: '/api/v1/hasl/recruit/service/deleteAccountAgent', //删除内勤人员
 listAccountAgentHistory: '/api/v1/hasl/recruit/service/listAccountAgentHistory', // 内勤修改记录

 queryAccountTestResultPage: '/api/v1/hasl/recruit/service/queryAccountTestResultPage', //获取性向测试结果列表
 exportExamResult: '/api/v1/hasl/recruit/service/exportExamResult', //导出性向测试结果列表
 
 queryAccountProfile: '/api/v1/hasl/recruit/service/queryAccountProfile', // 查询候选人画像
 getAccountProfile: '/api/v1/hasl/recruit/service/getAccountProfile', // 获取候选人画像
 saveAccountProfile: '/api/v1/hasl/recruit/service/saveAccountProfile', // 保存人员画像
 deleteAccountProfile: '/api/v1/hasl/recruit/service/deleteAccountProfile', // 删除候选人画像
 exportAccountProfile: '/api/v1/hasl/recruit/service/exportAccountProfile', // 导出人员画像
 copyByBranchAndDimension: '/api/v1/hasl/recruit/service/copyByBranchAndDimension', // 引用候选人画像

 getAccountListForPC: '/api/v1/hasl/recruit/service/getAccountListForPC', // 获取简历列表
 getInterviewers: '/api/v1/hasl/recruit/service/getInterviewers', // 获取面试官
 arrangeInterview: '/api/v1/hasl/recruit/service/arrangeInterview', // 人员安排
 exportAccount: '/api/v1/hasl/recruit/service/exportAccount', // 人员导出
 changeReviewer: '/api/v1/hasl/recruit/service/changeReviewer', // 更换面试官
 confirmOrAudit: '/api/v1/hasl/recruit/service/confirmOrAudit', // 机构/分工公司确认(审核)退回
 getAccountResume: '/api/v1/hasl/recruit/service/getAccountResume', // 获取候选人简历
 updateAccountInfo: '/api/v1/hasl/recruit/service/updateAccountInfo', //修改简历
 cancelInterview: '/api/v1/hasl/recruit/service/cancelInterview', // 作废面试
 modifyInterviewState: '/api/v1/hasl/recruit/service/modifyInterviewState', // 修改招募状态
 getAccountHistoryList: '/api/v1/hasl/recruit/service/getAccountHistoryList',// 候选人信息修改记录
 getRecruitFlowList: '/api/v1/hasl/recruit/service/getRecruitFlowList', // 招募流程记录

 sumAccount: '/api/v1/hasl/recruit/service/sumAccount', // 统计简历信息
 orgQueryOfPolicyList: '/api/v1/hasl/policy/service/orgQueryOfPolicyList', // 机构列表
 queryCustomerPlansByPc: '/api/v1/hasl/customer/service/queryCustomerPlansByPc', // 获取客户工作计划列表
 exportCustomerPlansByPc: '/api/v1/hasl/customer/service/exportCustomerPlansByPc', // 导出客户工作计划列表
 getEnum: '/api/v1/hasl/customer/service/getEnum', // 获取活动类型
 queryCustomerPlan: '/api/v1/hasl/customer/service/queryCustomerPlan', // 查看工作计划详情
};



// WEBPACK FOOTER //
// ./src/modules/url.js